<script setup>
import VInputReadonlyWithBlockLabel from "../../Form/Survey/VInputReadonlyWithBlockLabel.vue";
import VSelectWithBlockLabel from "../../Form/Survey/VSelectWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    is_this_your_first_time_in_sabah: answers?.is_this_your_first_time_in_sabah,
    what_is_your_main_purpose_visiting_sabah:
        answers?.what_is_your_main_purpose_visiting_sabah,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VInputReadonlyWithBlockLabel
                        elId="is_this_your_first_time_in_sabah"
                        v-model:value="form.is_this_your_first_time_in_sabah"
                        :label="
                            surveyFields['is_this_your_first_time_in_sabah']
                                ?.name
                        "
                        :isPlainText="false"
                    />
                </div>
                <div class="mb-3">
                    <VInputReadonlyWithBlockLabel
                        elId="what_is_your_main_purpose_visiting_sabah"
                        v-model:value="
                            form.what_is_your_main_purpose_visiting_sabah
                        "
                        :label="
                            surveyFields[
                                'what_is_your_main_purpose_visiting_sabah'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
